<template>
    <div>
      <canvas ref="pinballCanvas" width="800" height="600"></canvas>
      <div v-if="gameOver" class="game-over">
        <p>You lose! Score: {{ score }}</p>
        <button @click="restartGame">Play Again</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        canvas: null,
        ctx: null,
        ballRadius: 10,
        x: 0,
        y: 0,
        dx: 2,
        dy: -2,
        paddleWidth: 75,
        paddleHeight: 10,
        paddleX: 0,
        rightPressed: false,
        leftPressed: false,
        gameOver: false,
        score: 0,
        ballSpeed: 2, // Initial ball speed
      };
    },
    mounted() {
      this.canvas = this.$refs.pinballCanvas;
      this.ctx = this.canvas.getContext("2d");
  
      this.x = this.canvas.width / 2;
      this.y = this.canvas.height - 30;
      this.paddleX = (this.canvas.width - this.paddleWidth) / 2;
  
      document.addEventListener("keydown", this.keyDownHandler);
      document.addEventListener("keyup", this.keyUpHandler);
  
      this.draw();
    },
    methods: {
      keyDownHandler(e) {
        if (e.key == "Right" || e.key == "ArrowRight") {
          this.rightPressed = true;
        } else if (e.key == "Left" || e.key == "ArrowLeft") {
          this.leftPressed = true;
        }
      },
      keyUpHandler(e) {
        if (e.key == "Right" || e.key == "ArrowRight") {
          this.rightPressed = false;
        } else if (e.key == "Left" || e.key == "ArrowLeft") {
          this.leftPressed = false;
        }
      },
      drawBall() {
        this.ctx.beginPath();
        this.ctx.arc(this.x, this.y, this.ballRadius, 0, Math.PI * 2);
        this.ctx.fillStyle = "#0095DD";
        this.ctx.fill();
        this.ctx.closePath();
      },
      drawPaddle() {
        this.ctx.beginPath();
        this.ctx.rect(
          this.paddleX,
          this.canvas.height - this.paddleHeight,
          this.paddleWidth,
          this.paddleHeight
        );
        this.ctx.fillStyle = "#0095DD";
        this.ctx.fill();
        this.ctx.closePath();
      },
      draw() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.drawBall();
        this.drawPaddle();
  
        if (this.rightPressed && this.paddleX < this.canvas.width - this.paddleWidth) {
          this.paddleX += 7;
        } else if (this.leftPressed && this.paddleX > 0) {
          this.paddleX -= 7;
        }
  
        if (this.x + this.dx > this.canvas.width - this.ballRadius || this.x + this.dx < this.ballRadius) {
          this.dx = -this.dx;
        }
        if (this.y + this.dy < this.ballRadius) {
          this.dy = -this.dy;
        } else if (this.y + this.dy > this.canvas.height - this.ballRadius) {
          if (this.x > this.paddleX && this.x < this.paddleX + this.paddleWidth) {
            this.dy = -this.dy;
            this.score += 10;
            this.increaseBallSpeed(); // Increase ball speed when scoring
          } else {
            this.gameOver = true;
          }
        }
  
        this.ctx.font = "20px Arial";
        this.ctx.fillStyle = "#0095DD";
        this.ctx.fillText("Score: " + this.score, 10, 30);
  
        if (!this.gameOver) {
          this.x += this.dx * this.ballSpeed;
          this.y += this.dy * this.ballSpeed;
          requestAnimationFrame(this.draw);
        }
      },
      increaseBallSpeed() {
        // Increase ball speed by a factor (e.g., 1.1) when scoring
        this.ballSpeed *= 1.1;
      },
      restartGame() {
        this.ballSpeed = 2;
        this.score = 0;
        this.gameOver = false;
        this.x = this.canvas.width / 2;
        this.y = this.canvas.height - 30;
        this.paddleX = (this.canvas.width - this.paddleWidth) / 2;
        this.dx = 2;
        this.dy = -2;
        this.draw();
      },
    },
  };
  </script>
  
  <style>
  canvas {
    border: 1px solid black;
    display: block;
    margin: 0 auto;
  }
  .game-over {
    text-align: center;
    margin-top: 20px;
  }
  </style>
  